import { render, staticRenderFns } from "./AttrAdd.vue?vue&type=template&id=1d6fbb9c&scoped=true"
import script from "./AttrAdd.vue?vue&type=script&lang=js"
export * from "./AttrAdd.vue?vue&type=script&lang=js"
import style0 from "./AttrAdd.vue?vue&type=style&index=0&id=1d6fbb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fbb9c",
  null
  
)

export default component.exports